export const TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
import logo from './logos';
import useCaseImages from './useCaseImages';
/**
 *
 * @param {'sst'|'redbeam'} brand
 * @param {'white'|'color'|'small'} variant
 * @param {boolean} darkMode
 */
export async function getLogo(brand, variant, darkMode) {
    if (__UNIT_TESTING__) return TRANSPARENT_PIXEL;
    const mode = darkMode ? 'dark' : 'light';
    const image = logo[brand][variant]?.[mode] || logo[brand][variant];
    if (!image.image) {
        //weird peculiarity: If at least the "." is not added here
        //it complains about not being able to find the module.... :-S
        const result = await import('./' + image.path);
        image.image = result.default ?? result;
    }
    return image.image;
}

/**
 *
 * @param {string} useCase useCase name, e.g. "Item Tracking", or "Flair"
 * @returns
 */
export async function getUseCaseImage(useCase) {
    if (__UNIT_TESTING__) return TRANSPARENT_PIXEL;
    // easiest way to get around weird import issues/differences
    const image =
        useCaseImages[useCase] ||
        useCaseImages.default?.[useCase] ||
        useCaseImages.default.default ||
        useCaseImages.default;
    if (!image.image) {
        //weird peculiarity: If at least the "." is not added here
        //it complains about not being able to find the module.... :-S
        const result = await import('./' + image.path);
        image.image = result.default ?? result;
    }
    return image.image;
}

let imageCache = {};
/**
 *
 * @param {string} imagePath eg. rfidInlay.png
 * @returns
 */
export async function getImage(imagePath) {
    if (__UNIT_TESTING__) return TRANSPARENT_PIXEL;
    // Fall through assignment. `image` will end up with the same value as `imageCache[imagePath]`
    const image = (imageCache[imagePath] = imageCache[imagePath] || {
        path: imagePath
    });

    if (!image.image) {
        //weird peculiarity: If at least the "." is not added here
        //it complains about not being able to find the module.... :-S
        const result = await import('./' + image.path);
        image.image = result.default ?? result;
    }
    return image.image;
}
